<template>
  <div class="wrap container">
    <div class="main">
      <!-- 班级课程列表 -->
      <template v-if="activeIdx == 0">
        <div class="class_box" v-if="!empty">
          <vuedraggable
            class="vue-draggable"
            v-model="classList"
            :disabled="!sortClass"
            tag="ul"
            draggable=".draggable-item"
            animation="300"
            @start="onDragStart"
            @end="onDragEnd"
          >
            <!-- 拖拽元素 -->
            <li
              class="lesson draggable-item"
              v-for="item in classList"
              :key="item.classId"
              @click="goDetail(item.classId, item.courseId, item.weight)"
            >
              <div class="lesson_info">
                <div style="overflow: hidden">
                  <div class="left_info">
                    <p class="lesson_title">{{ item.courseTitle }}</p>
                    <p class="class_name">{{ item.name }}</p>
                  </div>
                  <div class="right_code">
                    <p>邀请码</p>
                    <p class="code">{{ item.classCode }}</p>
                  </div>
                </div>
                <!-- <div class="counts">
                  <div class="count_item">
                    <p>章节</p>
                    <p>{{ item.chapterCount || 0 }}</p>
                  </div>
                  <div class="count_item">
                    <p>团队</p>
                    <p>{{ item.teamCount || 0 }}</p>
                  </div>
                  <div class="count_item">
                    <p>学员数</p>
                    <p>{{ item.studentCount || 0 }}</p>
                  </div>
                  <div class="count_item">
                    <p>进度</p>
                    <p>{{ item.progress || 0 }}%</p>
                  </div>
                </div> -->
                <!-- <div class="bottom">
                  <el-button
                    class="btn"
                    type="primary"
                    @click="goDetail(item.classId, item.courseId, item.weight)"
                    >开始上课</el-button
                  >
                </div> -->
              </div>
              <div class="cover_box">
                <el-image class="cover" :src="item.icon" fit="cover"></el-image>
                <div class="mask">
                  <i class="el-icon-edit" @click.stop="handleEdit(item)"></i>
                  <i
                    class="el-icon-delete"
                    @click.stop="handleDel(item.classId)"
                  ></i>
                </div>
              </div>
            </li>
          </vuedraggable>
        </div>

        <!-- 空状态 -->
        <empty-status
          desc="您还没创建班级，请先创建属于您的班级"
          buttonText="创建班级"
          haveButton
          @btnClick="setClass"
          v-else
        />
      </template>

      <!-- 创建班级 -->
      <template v-else-if="activeIdx == 1">
        <establish-class :currentClass="currentClass" @back="back" />
      </template>

      <!-- 修改个人信息 -->
      <template v-else-if="activeIdx == 2">
        <modify-info :teacherInfo="teacherInfo" @back="back" />
      </template>

      <!-- 权限设置 -->
      <template v-else>
        <settings :classId="classId" @back="back" />
      </template>
    </div>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import { classList, delClass, sortClass } from "@/api/class";
import emptyStatus from "@/components/emptyStatus/index";
import establishClass from "./establishClass";
import modifyInfo from "./modifyInfo";
import settings from "./settings";
export default {
  components: {
    vuedraggable,
    emptyStatus,
    establishClass,
    modifyInfo,
    settings,
  },
  data() {
    return {
      activeIdx: 0,
      classList: [],
      empty: false,
      currentClass: {},
      sortClass: false,
      classId: null,
    };
  },
  created() {
    this.getClassList();
  },
  computed: {
    teacherInfo() {
      return this.$store.state.myInfo;
    },
  },
  methods: {
    // 班级列表
    getClassList() {
      this.$loading.show();
      classList().then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.classList = res.data;
          this.empty = res.data.length <= 0 ? true : false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 详情
    goDetail(id, courseId, weight) {
      if (!weight) {
        this.$message.warning("上课之前请先配置各项权重");
        this.classId = id;
        this.activeIdx = 3;
        return;
      }
      this.$router.push({
        path: "/classCourse",
        query: {
          id,
          courseId,
        },
      });
    },
    // 创建班级
    setClass() {
      this.currentClass = {};
      this.activeIdx = 1;
    },
    // 修改班级
    handleEdit(classItem) {
      this.activeIdx = 1;
      this.currentClass = classItem || {};
    },
    // 删除班级
    handleDel(classId) {
      this.$confirm(`确定要删除该班级吗？`, {
        type: "warning",
      })
        .then(() => {
          delClass(classId).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getClassList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    back(val, classId) {
      this.activeIdx = val;
      this.classId = classId || null;
      if (val == 0) {
        this.$store.dispatch("getUserInfo");
        this.getClassList();
      }
    },

    // 拖拽排序
    onDragStart(e) {
      e.target.classList.add("hideShadow");
    },
    onDragEnd(e) {
      e.target.classList.remove("hideShadow");
    },
    handleSort() {
      let arr = [];
      this.classList.forEach((item) => {
        arr.push(item.classId);
      });
      this.$loading.show();
      sortClass(arr).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.sortClass = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  padding-bottom: 20px;
  overflow: inherit;
  .info_box {
    width: 100%;

    .avatar {
      position: relative;
      display: inline-block;
      width: 240px;
      height: 240px;
      line-height: 240px;
      background: #d7d7d7;
      vertical-align: top;

      .img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
      }
    }

    .right {
      position: relative;
      display: inline-block;
      padding: 35px 70px;
      width: calc(100% - 240px);
      height: 240px;
      text-align: left;
      color: #fff;
      background: linear-gradient(180deg, #1976f5, #bd4593 100%);

      p {
        margin-bottom: 15px;

        &.name_row {
          padding-left: 35px;
          margin-bottom: 20px;

          span {
            font-size: 22px;
          }
        }

        .icon {
          margin-right: 19px;
          width: 18px;
          vertical-align: top;

          &.sex_icon {
            margin-left: 30px;
            width: 20px;
            vertical-align: -3px;
          }
        }
      }

      .set_btn {
        position: absolute;
        top: 34px;
        right: 20px;
        padding: 0;
        width: 120px;
        height: 35px;
        font-weight: bold;
        line-height: 35px;
        background: #ffffff;
        font-size: 18px;
        color: #1976f5;
        border-radius: 0;
      }

      .set_icon {
        position: absolute;
        right: 20px;
        bottom: 59px;
        width: 32px;
        cursor: pointer;
      }
    }
  }

  .main {
    position: relative;
    min-height: calc(100vh - 66px - 200px - 240px);

    .class_box {
      padding-top: 18px;
      padding-bottom: 15px;
      text-align: left;

      .title-row {
        margin-bottom: 18px;
        padding-left: 20px;
        height: 28px;
        line-height: 28px;
        border-left: 2px solid #1976f5;
        overflow: hidden;
        .title {
          float: left;
          line-height: 28px;
          text-align: left;
          font-size: 20px;
          font-weight: bold;
        }
      }

      // 拖拽
      .vue-draggable {
        &.hideShadow {
          .shadow {
            display: none;
          }
        }
      }

      .lesson {
        display: inline-block;
        margin-bottom: 16px;
        width: 227px;
        // border-radius: 10px;
        box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.2);
        overflow: hidden;

        &:not(:nth-child(5n)) {
          margin-right: 16px;
        }

        .cover_box {
          position: relative;
          width: 227px;
          height: 152px;
          overflow: hidden;

          &:hover {
            .cover {
              transform: scale(1.1, 1.1);
            }
            .mask {
              opacity: 1;
            }
          }

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            line-height: 152px;
            color: #fff;
            opacity: 0;
            font-size: 20px;
            text-align: center;
            background-color: rgba(0, 0, 0, 0.5);
            transition: opacity 0.3s;
            i {
              margin: 0 10px;
              cursor: pointer;
            }
          }
        }

        .cover {
          width: 100%;
          height: 100%;
          transition: all 0.5s ease;
        }

        .lesson_info {
          padding: 15px;

          .left_info {
            // float: left;

            .lesson_title,
            .class_name {
              max-width: 130px;
              color: #1976f5;
              font-size: 16px;
              font-weight: bold;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              &.class_name {
                font-size: 15px;
              }
            }
          }

          .right_code {
            // float: right;
            margin-top: 10px;

            p {
              text-align: center;
              font-size: 14px;

              &.code {
                color: #1976f5;
                font-weight: bold;
              }
            }
          }

          .counts {
            padding: 15px 10px 20px;

            .count_item {
              display: inline-block;
              margin: 0 5px;
              text-align: center;
              font-size: 14px;
              color: #000;
            }
          }

          .bottom {
            .btn {
              padding: 0;
              width: 100%;
              height: 36px;
              font-size: 16px;
              line-height: 36px;
              background: #1976f5;
            }
          }
        }
      }
    }
  }
}
</style>